<template>
  <Loader v-if="loader" />
  <div class="statistiche-container">
    <h2>Statistiche Validazioni Credito</h2>
    <p class="subtitle">Monitoraggio attività di validazione crediti</p>
    <div class="statistiche-boxes">
      <div class="stat-box blue">
        <div class="stat-value">{{ totaleFatture }}</div>
        <div class="stat-label">Totale</div>
      </div>
      <div class="stat-box green">
        <div class="stat-value">{{ totaleValidate }}</div>
        <div class="stat-label">Totale Validate</div>
      </div>
      <div class="stat-box orange">
        <div class="stat-value">{{ nonAncoraValidate }}</div>
        <div class="stat-label">Non Ancora Validate</div>
      </div>
    </div>
    <div class="statistiche-boxes">
      <div class="stat-box purple">
        <div class="stat-value">{{ dilazione }}</div>
        <div class="stat-label">Dilazione</div>
      </div>
      <div class="stat-box teal">
        <div class="stat-value">{{ rimanda }}</div>
        <div class="stat-label">Rimanda</div>
      </div>
      <div class="stat-box yellow">
        <div class="stat-value">{{ distacca }}</div>
        <div class="stat-label">Distacca</div>
      </div>
      <div class="stat-box blue">
        <div class="stat-value">{{ rilascioInTutela }}</div>
        <div class="stat-label">Rilascio in tutela</div>
      </div>
      <div class="stat-box green">
        <div class="stat-value">{{ mediaValidazioniGiorno }}</div>
        <div class="stat-label">Media Validazioni/Giorno</div>
      </div>
    </div>

    <div class="dettaglio-card">
      <div class="dettaglio-header">
        <span>Dettaglio Validazioni</span>
        <div style="display: flex; align-items: center; gap: 8px;">
          <Calendar class="ml-4" v-model="dateRange" selectionMode="range" dateFormat="dd/mm/yy" placeholder="Filtra per intervallo date" showIcon />
          <button class="show-all-btn" @click="mostraTuttiDettagli = true">Mostra tutto</button>
        </div>
      </div>
      <table class="dettaglio-table">
        <thead>
          <tr>
            <th @click="setSort('n_validazioni')" style="cursor:pointer">
              N.Validazioni
              <span v-if="sortKey === 'n_validazioni' && sortAsc">&#8593;</span>
              <span v-if="sortKey === 'n_validazioni' && !sortAsc">&#8595;</span>
            </th>
            <th>Utente</th>
            <th @click="setSort('data')" style="cursor:pointer">
              Giorno Validazione
              <span v-if="sortKey === 'data' && sortAsc">&#8593;</span>
              <span v-if="sortKey === 'data' && !sortAsc">&#8595;</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr 
            v-for="row in dettaglioPaginato" 
            :key="row.data + row.user_id"
            @click="mostraDettaglio(row)"
            :class="{ selected: dettaglioSelezionato && dettaglioSelezionato.row === row }"
            style="cursor:pointer"
          >
            <td>
              <span class="badge">{{ row.n_validazioni }}</span>
            </td>
            <td>
              <span class="user">
                <i class="pi pi-user"></i>
                {{ row.nome }} - {{ row.email }}
              </span>
            </td>
            <td>
              <i class="pi pi-calendar"></i>
              {{ formatDate(row.data) }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination" v-if="totalPages > 0">
        <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">&lt;</button>
        <button
          v-for="page in totalPages"
          :key="page"
          @click="goToPage(page)"
          :class="['page-btn', { active: page === currentPage }]"
        >
          {{ page }}
        </button>
        <button @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">&gt;</button>
        <span class="pagination-total">Totale: {{ dettaglioFiltrato.length }} record</span>
      </div>
      <div v-if="mostraTuttiDettagli" class="esploso-dettaglio">
        <div class="esploso-header">
          <h4>Esploso di tutte le validazioni.</h4>
          <button class="close-btn" @click="mostraTuttiDettagli = false" title="Chiudi dettaglio">✕</button>
        </div>
        <input
          v-model="searchEsplosoAll"
          class="search-input"
          type="text"
          placeholder="Cerca in tutte le validazioni..."
          style="margin-bottom: 10px; width: 300px;"
        />
        <table class="esploso-table">
          <thead>
            <tr>
              <th>Validatore</th>
              <th>Cliente</th>
              <th>Rappresentante</th>
              <th>Agente</th>
              <th>Totale Debito</th>
              <th>Nota</th>
              <th>Esito</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(det, idx) in tuttiDettagliFiltratiPaginati" :key="idx">
              <td>{{ det.nome }} - {{ det.email }}</td>
              <td>
                <span v-if="det.cliente_id">
                  <router-link :to="`/ask/clienti/${det.cliente_id}/dettagli`" target="_blank" class="entity-link">
                    {{ det.cliente_nome }}
                  </router-link>
                </span>
                <span v-else>{{ det.cliente_nome || '-' }}</span>
              </td>
              <td>
                <span v-if="det.rappresentante_id">
                  <router-link :to="`/ask/rappresentanti/${det.rappresentante_id}/dettagli`" target="_blank" class="entity-link">
                    {{ det.rappresentante_nome }}
                  </router-link>
                </span>
                <span v-else>{{ det.rappresentante_nome || '-' }}</span>
              </td>
              <td>
                <span v-if="det.agente_id">
                  <router-link :to="`/ask/agenti/${det.agente_id}/dettagli`" target="_blank" class="entity-link">
                    {{ det.agente_nome }}
                  </router-link>
                </span>
                <span v-else>{{ det.agente_nome || '-' }}</span>
              </td>
              <td>{{ det.totale_debito }} €</td>
              <td>{{ det.note }}</td>
              <td>{{ det.esito_descrizione }}</td>
              <td>{{ formatDate(det.data_fine) }}</td>
            </tr>
          </tbody>
        </table>
        <div class="pagination" v-if="esplosoAllTotalPages > 0">
          <button @click="goToEsplosoAllPage(esplosoAllPage - 1)" :disabled="esplosoAllPage === 1">&lt;</button>
          <button
            v-for="page in esplosoAllTotalPages"
            :key="page"
            @click="goToEsplosoAllPage(page)"
            :class="['page-btn', { active: page === esplosoAllPage }]"
          >
            {{ page }}
          </button>
          <button @click="goToEsplosoAllPage(esplosoAllPage + 1)" :disabled="esplosoAllPage === esplosoAllTotalPages">&gt;</button>
          <span class="pagination-total">Totale: {{ tuttiDettagliFiltrati.length }} record</span>
        </div>
      </div>
      <div v-if="dettaglioSelezionato && !mostraTuttiDettagli" class="esploso-dettaglio">
        <div class="esploso-header">
          <h4>Dettaglio Validazioni {{ dettaglioSelezionato.row.nome }} - Data: {{ formatDate(dettaglioSelezionato.row.data) }}</h4>
          <button class="close-btn" @click="dettaglioSelezionato = null" title="Chiudi dettaglio">✕</button>
        </div>
        <input
          v-model="searchEsploso"
          class="search-input"
          type="text"
          placeholder="Cerca nei dettagli..."
          style="margin-bottom: 10px; width: 300px;"
        />
        <table class="esploso-table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Rappresentante</th>
              <th>Agente</th>
              <th>Totale Debito</th>
              <th>Nota</th>
              <th>Esito</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(det, idx) in dettagliPaginati" :key="idx">
              <td>
                <span v-if="det.cliente_id">
                  <router-link :to="`/ask/clienti/${det.cliente_id}/dettagli`" target="_blank" class="entity-link">
                    {{ det.cliente_nome || '-' }}
                  </router-link>
                </span>
                <span v-else>{{ det.cliente_nome || '-' }}</span>
              </td>
              <td>
                <span v-if="det.rappresentante_id">
                  <router-link :to="`/ask/rappresentanti/${det.rappresentante_id}/dettagli`" target="_blank" class="entity-link">
                    {{ det.rappresentante_nome || '-' }}
                  </router-link>
                </span>
                <span v-else>{{ det.rappresentante_nome || '-' }}</span>
              </td>
              <td>
                <span v-if="det.agente_id">
                  <router-link :to="`/ask/agenti/${det.agente_id}/dettagli`" target="_blank" class="entity-link">
                    {{ det.agente_nome || '-' }}
                  </router-link>
                </span>
                <span v-else>{{ det.agente_nome || '-' }}</span>
              </td>
              <td>{{ det.totale_debito }} €</td>
              <td>{{ det.note }}</td>
              <td>{{ det.esito_descrizione }}</td>
              <td>{{ formatDate(det.data_fine) }}</td>
            </tr>
          </tbody>
        </table>
        <div class="pagination" v-if="esplosoTotalPages > 0">
          <button @click="goToEsplosoPage(esplosoPage - 1)" :disabled="esplosoPage === 1">&lt;</button>
          <button
            v-for="page in esplosoTotalPages"
            :key="page"
            @click="goToEsplosoPage(page)"
            :class="['page-btn', { active: page === esplosoPage }]"
          >
            {{ page }}
          </button>
          <button @click="goToEsplosoPage(esplosoPage + 1)" :disabled="esplosoPage === esplosoTotalPages">&gt;</button>
          <span class="pagination-total">Totale: {{ dettaglioSelezionato.row.n_validazioni }} record</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Service from '@/services/ask-management/recupero-credito-service'
import { ref, getCurrentInstance, onMounted, computed, watch } from 'vue';
import { useToast } from "primevue/usetoast";
import Loader from '@/components/Loader.vue'
import Calendar from 'primevue/calendar';

export default {
  components: { Loader, Calendar },
  setup() {
    const loader = ref(false);
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const service = new Service(self.$http, self.$eventBus);
    const toast = useToast();

    const totaleFatture = ref(0);
    const totaleValidate = ref(0);
    const nonAncoraValidate = ref(0);
    const dilazione = ref(0);
    const rimanda = ref(0);
    const distacca = ref(0);
    const rilascioInTutela = ref(0);
    const mediaValidazioniGiorno = ref(0);
    const dettaglio = ref([]);

    const oggi = new Date();
    oggi.setHours(0, 0, 0, 0); 
    const dateRange = ref([oggi, oggi]); 
    const sortAsc = ref(true);
    const sortKey = ref('data');
    const currentPage = ref(1);
    const pageSize = 20;

    const dettaglioFiltrato = computed(() => {
      let risultati = [];
      dettaglio.value.forEach(utente => {
        utente.giorni.forEach(giorno => {
          risultati.push({
            ...giorno,
            user_id: utente.user_id,
            nome: utente.nome,
            email: utente.email
          });
        });
      });

      
      risultati.sort((a, b) => {
        if (sortKey.value === 'data') {
          return sortAsc.value
            ? a.data.localeCompare(b.data)
            : b.data.localeCompare(a.data);
        }
        if (sortKey.value === 'n_validazioni') {
          return sortAsc.value
            ? a.n_validazioni - b.n_validazioni
            : b.n_validazioni - a.n_validazioni;
        }
        return 0;
      });

      return risultati;
    });

    const setSort = (key) => {
      if (sortKey.value === key) {
        sortAsc.value = !sortAsc.value;
      } else {
        sortKey.value = key;
        sortAsc.value = true;
      }
    };

    const dettaglioPaginato = computed(() => {
      const start = (currentPage.value - 1) * pageSize;
      const end = start + pageSize;
      return dettaglioFiltrato.value.slice(start, end);
    });

    const totalPages = computed(() => {
      return Math.ceil(dettaglioFiltrato.value.length / pageSize);
    });

    const goToPage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
      }
    };

    const formatDateForFilter = (dateObj) => {
      if (!dateObj) return '';
      const d = new Date(dateObj);
      const month = '' + (d.getMonth() + 1);
      const day = '' + d.getDate();
      const year = d.getFullYear();
      return [year, month.padStart(2, '0'), day.padStart(2, '0')].join('-');
    };

    const loadData = async () => {
      try {
        loader.value = true;
        
        const params = {};
        if (dateRange.value && dateRange.value[0] && dateRange.value[1]) {
          params.data_inizio = formatDateForFilter(dateRange.value[0]);
          params.data_fine = formatDateForFilter(dateRange.value[1]);
        }
        
        const response = await service.getInfoValidazioniCredito(params);
        if (response.success) {
          totaleFatture.value = response.totale_validazioni;
          totaleValidate.value = response.totale_validate;
          nonAncoraValidate.value = response.non_ancora_validate;
          dilazione.value = response.dilazione;
          rimanda.value = response.rimanda;
          distacca.value = response.distacca;
          rilascioInTutela.value = response.rilascio_in_tutela;
          mediaValidazioniGiorno.value = response.media_validazioni_giorno;
          dettaglio.value = response.dettaglio_per_utente;
        } else {
          toast.add({ severity: 'error', summary: 'Errore', detail: response.message, life: 3000 });
        }
      } catch (error) {
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore nel caricamento dei dati', life: 3000 });
      } finally {
        loader.value = false;
      }
    };

    const formatDate = (dateStr) => {
      if (!dateStr) return '';
      const datePart = dateStr.split(' ')[0].split('T')[0];
      const [year, month, day] = datePart.split('-');
      return `${day}/${month}/${year}`;
    };

    const dettaglioSelezionato = ref(null);
    const mostraDettaglio = (row) => {
      if (dettaglioSelezionato.value && dettaglioSelezionato.value.row === row) {
        dettaglioSelezionato.value = null;
      } else {
        dettaglioSelezionato.value = {
          row,
          dettagli: row.dettagli || []
        };
      }
    };

    const esplosoPage = ref(1);
    const esplosoPageSize = 20;

    const goToEsplosoPage = (page) => {
      if (page >= 1 && page <= esplosoTotalPages.value) {
        esplosoPage.value = page;
      }
    };
    watch(dettaglioSelezionato, () => {
      esplosoPage.value = 1;
    });

    const mostraTuttiDettagli = ref(false);
    const tuttiDettagli = computed(() => {
      let all = [];
      dettaglioFiltrato.value.forEach(row => {
        if (row.dettagli && row.dettagli.length) {
          all = all.concat(row.dettagli.map(det => ({
            ...det,
            nome: row.nome,
            email: row.email,
            data: row.data
          })));
        }
      });
      return all;
    });

    const searchEsploso = ref('');
    const searchEsplosoAll = ref('');

    const dettagliFiltrati = computed(() => {
      if (!dettaglioSelezionato.value) return [];
      if (!searchEsploso.value) return dettaglioSelezionato.value.dettagli;
      const q = searchEsploso.value.toLowerCase();
      return dettaglioSelezionato.value.dettagli.filter(det =>
        Object.values(det).some(val =>
          val && val.toString().toLowerCase().includes(q)
        )
      );
    });
    const dettagliPaginati = computed(() => {
      const start = (esplosoPage.value - 1) * esplosoPageSize;
      const end = start + esplosoPageSize;
      return dettagliFiltrati.value.slice(start, end);
    });
    const esplosoTotalPages = computed(() => {
      if (!dettagliFiltrati.value) return 0;
      return Math.ceil(dettagliFiltrati.value.length / esplosoPageSize);
    });

    const tuttiDettagliFiltrati = computed(() => {
      if (!searchEsplosoAll.value) return tuttiDettagli.value;
      const q = searchEsplosoAll.value.toLowerCase();
      return tuttiDettagli.value.filter(det =>
        Object.values(det).some(val =>
          val && val.toString().toLowerCase().includes(q)
        )
      );
    });

    const esplosoAllPage = ref(1);
    const esplosoAllPageSize = 50;

    const tuttiDettagliFiltratiPaginati = computed(() => {
      const start = (esplosoAllPage.value - 1) * esplosoAllPageSize;
      const end = start + esplosoAllPageSize;
      return tuttiDettagliFiltrati.value.slice(start, end);
    });
    const esplosoAllTotalPages = computed(() => {
      return Math.ceil(tuttiDettagliFiltrati.value.length / esplosoAllPageSize);
    });
    const goToEsplosoAllPage = (page) => {
      if (page >= 1 && page <= esplosoAllTotalPages.value) {
        esplosoAllPage.value = page;
      }
    };
    watch(mostraTuttiDettagli, (val) => {
      if (val) esplosoAllPage.value = 1;
    });

    watch(dateRange, () => {
      currentPage.value = 1; 
      loadData();
    });

    onMounted(loadData);

    return {
      loader,
      totaleFatture,
      totaleValidate,
      nonAncoraValidate,
      dilazione,
      rimanda,
      distacca,
      rilascioInTutela,
      mediaValidazioniGiorno,
      dettaglio,
      formatDate,
      dateRange,
      dettaglioFiltrato,
      dettaglioPaginato,
      sortAsc,
      currentPage,
      pageSize,
      totalPages,
      goToPage,
      setSort,
      sortKey,
      mostraDettaglio,
      dettaglioSelezionato,
      esplosoPage,
      esplosoPageSize,
      dettagliPaginati,
      esplosoTotalPages,
      goToEsplosoPage,
      mostraTuttiDettagli,
      tuttiDettagli,
      searchEsploso,
      searchEsplosoAll,
      dettagliFiltrati,
      tuttiDettagliFiltrati,
      esplosoAllPage,
      esplosoAllPageSize,
      tuttiDettagliFiltratiPaginati,
      esplosoAllTotalPages,
      goToEsplosoAllPage,
    };
  }
}
</script>

<style scoped>
.statistiche-container {
  background: #f4f7fa;
  padding: 32px 0;
  min-height: 100vh;
}
.statistiche-boxes {
  display: flex;
  gap: 24px;
  margin: 32px 0 24px 0;
}
.stat-box {
  flex: 1;
  border-radius: 12px;
  padding: 32px 0 24px 0;
  text-align: center;
  color: #fff;
  font-weight: 600;
  font-size: 1.2rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.stat-box .stat-value {
  font-size: 2.5rem;
  font-weight: bold;
}
.stat-box.blue { background: linear-gradient(90deg, #2980b9, #6dd5fa); }
.stat-box.green { background: linear-gradient(90deg, #11998e, #38ef7d); }
.stat-box.orange { background: linear-gradient(90deg, #f7971e, #ffd200); color: #fff; }
.stat-box.purple { background: linear-gradient(90deg, #8e54e9, #4776e6); }
.stat-box.teal { background: linear-gradient(90deg, #43cea2, #185a9d); }
.stat-box.yellow { background: linear-gradient(90deg, #f7971e, #ffd200); color: #fff; }
.dettaglio-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
  margin-top: 24px;
  padding: 0;
  overflow: hidden;
}
.dettaglio-header {
  background: #0f5889;
  color: #fff;
  font-weight: 600;
  padding: 16px 24px;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.dettaglio-table {
  width: 100%;
  border-collapse: collapse;
}
.dettaglio-table th, .dettaglio-table td {
  padding: 12px 18px;
  text-align: left;
}
.dettaglio-table th {
  background: #0f5889 ;
  color: #fff;
  font-weight: 500;
  user-select: none;
}
.dettaglio-table th[style*="cursor:pointer"] {
  user-select: none;
}
.dettaglio-table tr {
  background: #f8fafc;
  border-bottom: 1px solid #e0e7ef;
}
.dettaglio-table tr:nth-child(even) {
  background: #e9f5fb;
}
.badge {
  background: #0f5889;
  color: #fff;
  border-radius: 16px;
  padding: 4px 16px;
  font-weight: bold;
  font-size: 1.1rem;
}
.user {
  color: #0f5889;
  font-weight: 500;
}
.subtitle {
  color: #7b8794;
  margin-bottom: 0;
  margin-top: 0;
}
.calendar-filter {
  margin: 16px 0 8px 0;
  display: flex;
  justify-content: flex-end;
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 16px 24px 16px 0;
  flex-wrap: wrap;
}
.pagination button {
  background: #17406d;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}
.pagination button:disabled {
  background: #2980b9;
  cursor: not-allowed;
}
.page-btn.active {
  background: #2980b9;
  font-weight: bold;
  border: 2px solid #fff;
}
.pagination-total {
  margin-left: 16px;
  color: #17406d;
  font-weight: 500;
}
.esploso-dettaglio {
  background: #f8fafc;
  border-radius: 10px;
  margin: 24px 0 0 0;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.esploso-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
}
.esploso-table th {
  background: #0f5889;
  color: #fff;
  font-weight: 500;
  user-select: none;
}
.esploso-table th, .esploso-table td {
  padding: 12px 18px;
  border-bottom: 1px solid #e0e7ef;
  text-align: left;
}
.esploso-table tr {
  background: #f8fafc;
}
.esploso-table tr:nth-child(even) {
  background: #e9f5fb;
}
.esito-confermato {
  color: #1abc9c;
  font-weight: bold;
}
.esito-respinto {
  color: #e74c3c;
  font-weight: bold;
}
tr.selected {
  background: #e0f3ff !important;
}
.pod-link {
  color: #2980b9;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}
.pod-link:hover {
  color: #17406d;
}
.entity-link {
  color: #2980b9;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}
.entity-link:hover {
  color: #17406d;
}
.esploso-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.close-btn {
  background: #e74c3c;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 1.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}
.close-btn:hover {
  background: #c0392b;
}
.show-all-btn {
  margin-left: 12px;
  background: #ffffff;
  color: #17406d;
  border: none;
  border-radius: 6px;
  padding: 6px 16px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.show-all-btn:hover {
  background: #17406d;
  color: #fff;
}
.search-input {
  border: 1px solid #b0b8c1;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 1rem;
  margin-right: 8px;
}
.search-input:focus {
  outline: none;
  border-color: #2980b9;
}
</style>